import React, { useState } from "react";
import { getUserInfo } from "@/models/User";
import style from "./Style.module.scss";
import ModalRule from "@/components/ModalRule";
import ModalHistory from "@/components/ModalHistory";

const Header: React.FC = () => {
  const userData = getUserInfo();

  const [modalRule, setModalRule] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);

  const scrollTo = (e: React.SyntheticEvent, ele: string) => {
    e.preventDefault();
    const section = document.getElementById(ele);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <header className={`${style["header"]}`}>
        <div className={`${style["header__wrap"]}`}>
          <a href="#" className={`${style["header__logo"]}`}>
            <img src="/images/logo.png?v=1" alt="" />
          </a>
          <div className={`${style["header__right"]}`}>
            <div className={`${style["header__menu"]}`}>
              <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  setModalRule(true);
                }}
              >
                <span>Hướng dẫn</span>
              </a>
              <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (!userData?.uid) {
                    window.location.href = "/user/login";
                    return;
                  }
                  setModalHistory(true);
                }}
              >
                <span>Lịch sử</span>
              </a>
              {/* <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(e, "section3");
                }}
              >
                <span>Spin</span>
              </a> */}
              <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(e, "section4");
                }}
              >
                <span>Cổ vũ</span>
              </a>
              <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(e, "section5");
                }}
              >
                <span>Shop</span>
              </a>
              <a
                href="#"
                className={`${style["header__menu__link"]}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(e, "section6");
                }}
              >
                <span>BXH</span>
              </a>
            </div>
            {userData?.accountName && (
              <div className={`${style["header__info"]}`}>
                <span className={`${style["header__info__iconAvatar"]}`}></span>HI<span className="nickname">{userData?.accountName}</span>
                <em>|</em>
              </div>
            )}
            <div className={`${style["header__btn"]}`}>
              {userData?.uid ? (
                <a
                  href="/user/logout"
                  className={`${style["header__btn__link"]}`}
                >
                  <span>Đăng xuất</span>
                  {/* <img src="/images/icon-logout.png" alt="" /> */}
                </a>
              ) : (
                <a
                  href="/user/login"
                  className={`${style["header__btn__link"]}`}
                >
                  <span>Đăng nhập</span>
                  {/* <img src="/images/icon-login.png" alt="" /> */}
                </a>
              )}
            </div>
          </div>
        </div>
      </header>
      {modalRule && (
        <ModalRule
          modalStatus={modalRule}
          closeModal={() => setModalRule(false)}
        />
      )}
      {modalHistory && (
        <ModalHistory
          modalStatus={modalHistory}
          closeModal={() => setModalHistory(false)}
        />
      )}
    </>
  );
};

export default Header;
